import { useState, useEffect, useRef } from "react";

import { clearAlert, useAlert } from "@lib/stores";

export const useAlertHandler = (type?: "page" | "modal") => {
  const alertRef = useRef<HTMLDivElement>(null);

  const ref = alertRef.current;

  const [isAlertDelayed, setIsAlertDelayed] = useState(false);

  const { data: alert } = useAlert();

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (alert.show && alert.for === (type || "page")) {
      ref?.classList.remove("hidden");
      ref?.classList.add("block");

      setTimeout(() => {
        ref?.classList.remove("opacity-0");
        ref?.classList.add("opacity-100");
      }, 0);

      timeout = setTimeout(() => {
        setIsAlertDelayed(true);
      }, 2000);
    }

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert, ref]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isAlertDelayed) {
      timeout = setTimeout(() => {
        clearAlert();

        setIsAlertDelayed(false);

        ref?.classList.remove("opacity-100");
        ref?.classList.add("opacity-0");
        ref?.classList.remove("block");
        ref?.classList.add("hidden");
      }, 150);
    }

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAlertDelayed, ref]);

  return { alertRef, alert, clearAlert };
};
